export default __webpack_public_path__ + "static/media/us-mobile.95519669.jpg";